import React from "react";
import { motion } from "framer-motion";
import { CHAPTERS } from "../data/bookContent";
import { ChevronRight } from "lucide-react";

export default function TableOfContents({ onJump, currentPageIndex }) {
  return (
    <div className="book-page max-w-3xl mx-auto px-6 sm:px-12 py-10 sm:py-14" data-testid="table-of-contents">
      <div className="flex items-baseline justify-between border-b border-cyan-400/20 pb-4 mb-8">
        <h2 className="font-display text-4xl sm:text-5xl font-extrabold text-white">
          Contents
        </h2>
        <span className="text-slate-500 font-heading uppercase text-xs tracking-widest">
          Tap any chapter
        </span>
      </div>

      <ol className="space-y-1">
        {CHAPTERS.map((c, i) => (
          <motion.li
            key={c.id}
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: i * 0.04, duration: 0.35 }}
          >
            <button
              onClick={() => onJump(c.id)}
              data-testid={`toc-chapter-${c.id}`}
              className="group w-full text-left flex items-center gap-4 py-3 px-3 rounded-md hover:bg-cyan-400/5 transition-colors border border-transparent hover:border-cyan-400/20"
            >
              <span className="font-mono text-xs text-cyan-400/70 w-14 shrink-0">
                {String(i + 1).padStart(2, "0")}
              </span>
              <span className="flex-1 min-w-0">
                <span className="block font-heading text-base sm:text-lg text-slate-100 group-hover:text-cyan-300 transition-colors font-semibold">
                  {c.title}
                </span>
                <span className="block text-sm text-slate-400 font-body mt-0.5">
                  {c.summary}
                </span>
              </span>
              <ChevronRight size={18} className="text-slate-600 group-hover:text-cyan-300 group-hover:translate-x-1 transition-all shrink-0" />
            </button>
          </motion.li>
        ))}
      </ol>

      <div className="mt-10 pt-6 border-t border-cyan-400/20 flex items-center justify-between text-sm">
        <button
          onClick={() => onJump("__index__")}
          data-testid="toc-jump-to-index-btn"
          className="font-heading text-cyan-300 hover:text-cyan-200 uppercase tracking-widest text-xs"
        >
          Jump to Index →
        </button>
        <span className="text-slate-600 text-xs">Page {currentPageIndex + 1}</span>
      </div>
    </div>
  );
}
